"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.product = void 0;
var utils_1 = require("../../utils");
var qs = require('qs');
exports.product = function (axios) {
    return {
        getProducts: function (getProductsRequest) {
            return axios.get('/products', getProductsRequest);
        },
        getProductEnumsPaymentMeans: function (getProductEnumsPaymentMeansRequest) {
            return axios.get('/product-enums/payment-means', getProductEnumsPaymentMeansRequest);
        },
        getProductEnumsSalesUnit: function () {
            return axios.get('/product-enums/sales-unit');
        },
        getProductsSummaries: function (productsSummariesRequest) {
            return axios.get('/products/summaries', productsSummariesRequest);
        },
        getProductsSummariesBySearchType: function (request) {
            return axios.get("/products/summaries/" + request.pathParams.searchType, request);
        },
        /** @deprecated postProductsV2를 사용하세요 */
        postProducts: function (postProductsRequest) {
            return axios.post('/products', postProductsRequest.data);
        },
        postProductsV2: function (_a) {
            var data = _a.data;
            return axios.post('/products', data);
        },
        postProductsByMallProductNo: function (postProductsByMallProductNoRequest) {
            return axios.post("/products/" + postProductsByMallProductNoRequest.params.mallProductNo + "?" + qs.stringify(postProductsByMallProductNoRequest.params, { arrayFormat: 'repeat' }), postProductsByMallProductNoRequest.data);
        },
        postProductsByMallProductNoV2: function (_a) {
            var params = _a.params, data = _a.data;
            return axios.post("/products/" + params.mallProductNo + "?" + qs.stringify(params, { arrayFormat: 'repeat' }), data);
        },
        getProductsSearch: function (productsSearchRequest) {
            return axios.get('/products/search', productsSearchRequest);
        },
        /** @deprecated postProductsSearchV2 사용해주세요 */
        postProductsSearch: function (productsSearchPostRequest) {
            return axios.post('/products/search', productsSearchPostRequest.data);
        },
        postProductsSearchV2: function (productsSearchPostRequest) {
            return axios.post('/products/search', productsSearchPostRequest.data);
        },
        /** response 임시 타입 지정. V2에 적용 예정. */
        postProductsSearchV3: function (productsSearchPostRequest) {
            return axios.post('/products/search', productsSearchPostRequest.data);
        },
        getProductsSearchAllAtOnce: function (productsSearchRequest) {
            return axios.get('/products/search-all-at-once', productsSearchRequest);
        },
        postProductsSearchAllAtOnce: function (productsSearchPostRequest) {
            return axios.post('/products/search-all-at-once', productsSearchPostRequest.data);
        },
        getProductsExcelSearch: function (productsSearchExcelRequest) {
            return axios.get('/products/search/excel', productsSearchExcelRequest);
        },
        getProductsSaleAgreements: function (getProductsSaleAgreementsRequest) {
            return axios.get('/products/sale-agreements', getProductsSaleAgreementsRequest);
        },
        getProductsCheckManagementCode: function (getProductsCheckManagementCodeRequest) {
            return axios.get('/products/check-management-code', getProductsCheckManagementCodeRequest);
        },
        getProductImage: function (getProductImageRequest) {
            return axios.get("/products/" + getProductImageRequest.params.productNo + "/image");
        },
        getProductDuty: function (getProductDutyRequest) {
            return axios.get("/products/" + getProductDutyRequest.params.productNo + "/duty-category");
        },
        getProductDutyV2: function (getProductDutyRequest) {
            return axios.get("/products/" + getProductDutyRequest.params.productNo + "/duty-category");
        },
        patchProductImage: function (patchProductsByMallProductNoRequest) {
            return axios.patch("/products/" + patchProductsByMallProductNoRequest.params.mallProductNo, patchProductsByMallProductNoRequest.data);
        },
        patchProductDuty: function (patchProductDutyRequest) {
            return axios.patch("/products/" + patchProductDutyRequest.params.mallProductNo, patchProductDutyRequest.data);
        },
        patchProductsDuty: function (patchProductsDutyRequest) {
            var data = qs.stringify(patchProductsDutyRequest.params);
            return axios.patch("/products?" + data, patchProductsDutyRequest.data);
        },
        getProductByNo: function (getProductByNoRequest) {
            return axios.get("/products/" + getProductByNoRequest.params.mallProductNo, getProductByNoRequest);
        },
        getProductByNoV2: function (getProductByNoRequest) {
            return axios.get("/products/" + getProductByNoRequest.params.mallProductNo, getProductByNoRequest);
        },
        putProductByNo: function (putProductByNoRequest) {
            return axios.put("/products/" + putProductByNoRequest.params.mallProductNo, putProductByNoRequest.data);
        },
        putProductByNoV2: function (putProductByNoRequest) {
            return axios.put("/products/" + putProductByNoRequest.params.mallProductNo, putProductByNoRequest.data);
        },
        putProductsSaleStatus: function (_a) {
            var data = _a.data;
            return axios.put('/products/sale-status', data);
        },
        putProductsFrontdisplay: function (_a) {
            var data = _a.data;
            return axios.put('/products/front-display', data);
        },
        patchProductsSalePeriod: function (_a) {
            var data = _a.data, params = _a.params;
            return axios.patch("/products?" + qs.stringify(params, { arrayFormat: 'repeat' }), data);
        },
        patchProducts: function (_a) {
            var data = _a.data, params = _a.params;
            return axios.patch("/products?" + qs.stringify(params, { arrayFormat: 'repeat' }), data);
        },
        patchProductsV2: function (_a) {
            var data = _a.data, params = _a.params;
            return axios.patch("/products?" + qs.stringify(params, { arrayFormat: 'repeat' }), data);
        },
        putInspections: function (_a) {
            var data = _a.data;
            return axios.put('/inspections', data);
        },
        getProductDeliveryTemplatesByNo: function (getProductDeliveryTemplatesByNoRequest) {
            var url = "/products/delivery-templates/" + getProductDeliveryTemplatesByNoRequest.params.deliveryTemplateNo;
            return axios.get(url, getProductDeliveryTemplatesByNoRequest);
        },
        getProductsDetailUrls: function () {
            return axios.get('/products/product-detail-urls');
        },
        /** @deprecated getProductsSearchStickerV2 사용해주세요 */
        getProductsSearchSticker: function (getProductsSearchStickerRequest) {
            return axios.get('/products/search/sticker', getProductsSearchStickerRequest);
        },
        getProductsSearchStickerV2: function (getProductsSearchStickerRequest) {
            return axios.get('/products/search/sticker', getProductsSearchStickerRequest);
        },
        getProductsSearchByKey: function (request) {
            return axios.get('/products/search-by-key', request);
        },
        /** @deprecated postProductsSearchByKeyV2를 사용하세요 */
        postProductsSearchByKey: function (request) {
            var mallProductNos = request.data.mallProductNos.map(function (productNo) { return productNo.toString().trim(); }).filter(Boolean);
            return axios.post('/products/search-by-key', __assign(__assign({}, request.data), { mallProductNos: mallProductNos }));
        },
        /**
         * @description mallProductNos 내부에 공백제거 로직 포함 되어있음
         */
        postProductsSearchByKeyV2: function (request) {
            var mallProductNos = request.data.mallProductNos.map(function (productNo) { return productNo.toString().trim(); }).filter(Boolean);
            return axios.post('/products/search-by-key', __assign(__assign({}, request.data), { mallProductNos: mallProductNos }));
        },
        getProductsSearchForDisplayCategory: function (request) {
            return axios.get('/products/search-for-display-category', request);
        },
        putProductsSalePrice: function (_a) {
            var data = _a.data;
            return axios.put('/products/sale-price', data);
        },
        getProductsWaitingSalesAgreementsCount: function () {
            return axios.get('/products/waiting-sales-agreements/count');
        },
        getProductsProductNoCustomerDemands: function (getProductsProductNoCustomerDemandsRequest) {
            return axios.get("/products/" + getProductsProductNoCustomerDemandsRequest.params.productNo + "/customer-demands", getProductsProductNoCustomerDemandsRequest);
        },
        getProductsProductNoSettings: function (getProductsProductNoSettingsRequest) {
            return axios.get("/products/" + getProductsProductNoSettingsRequest.params.productNo + "/settings", getProductsProductNoSettingsRequest);
        },
        putProductsExcelBulkAdminUpdate: function (request) {
            var query = qs.stringify(request.params);
            return axios.put("/products/excel/bulk/admin-update?" + query, request.data);
        },
        getProductsMallProductNo: function (request) {
            var url = utils_1.paramPathchange('/products/{mallProductNo}', request);
            return axios.get(url, request);
        },
        getProductsApprovalWaiting: function (productsApprovalWaitingRequest) {
            return axios.get('/products/approval-waiting', productsApprovalWaitingRequest);
        },
        getInspectionsView: function (getInspectionsViewRequest) {
            return axios.get("/inspections/" + getInspectionsViewRequest.params.mallProductNo + "/view", getInspectionsViewRequest);
        },
        getInspectionsViewV2: function (getInspectionsViewRequest) {
            return axios.get("/inspections/" + getInspectionsViewRequest.params.mallProductNo + "/view", getInspectionsViewRequest);
        },
        putInspectionsMallProductNo: function (_a) {
            var data = _a.data, params = _a.params;
            return axios.put("/inspections/" + params.mallProductNo, data);
        },
        getProductsPriceComparisonSite: function (_a) {
            var productNo = _a.params.productNo;
            return axios.get("/products/" + productNo + "/price-comparison-site");
        },
        getProductsPromotionSetting: function (_a) {
            var productNo = _a.params.productNo;
            return axios.get("/products/" + productNo + "/promotion-setting");
        },
        putProductsCategoryMappings: function (request) {
            return axios.put('/products/category-mappings', request.data);
        },
        putProductsMultiCategoryMappings: function (_a) {
            var data = _a.data;
            return axios.put('/products/multi-category-mappings', data);
        },
        getProductsStatusInspections: function () {
            return axios.get('/products/status/inspections');
        },
        getProductDisplayCategories: function (_a) {
            var productNo = _a.params.productNo;
            return axios.get("/products/" + productNo + "/display-categories");
        },
        getProductsConfigurable: function (request) {
            return axios.get('/products/configurable-products', request);
        },
        deleteProducts: function (_a) {
            var data = _a.data;
            return axios.delete("/products?" + qs.stringify(data, { arrayFormat: 'comma' }));
        },
        getProductsImmutableFields: function (request) {
            return axios.get("/products/" + request.params.productNo + "/immutable-fields", request);
        },
        postProductsExcel: function (request) {
            axios.defaults.timeout = 30 * 60 * 1000;
            return axios
                .post('/products/excel', request.data, { headers: { Version: '2.0' } })
                .then(function (res) {
                return res;
            })
                .finally(function () {
                axios.defaults.timeout = 30 * 1000;
            });
        },
        getProductsExcelFailResults: function (request) {
            return axios.get("/products/excel/fail-results/" + request.params.seq, __assign(__assign({}, request), { headers: { Version: '2.0' } }));
        },
        putProductsPrice: function (_a) {
            var data = _a.data;
            return axios.put('/products/price', data);
        },
        putProductsPriceV2: function (_a) {
            var data = _a.data;
            return axios.put('/products/price', data);
        },
        getProductSearchForSyncStock: function (productSearchForSyncStockRequest) {
            return axios.get('/products/search-for-sync-stock', productSearchForSyncStockRequest);
        },
        getProductsExcelRegisterForm: function (request) {
            return axios.get('/products/excel/register-form', __assign(__assign({}, request), { headers: { Version: '2.0' }, responseType: 'blob' }));
        },
        getProductsSearchExcelByTargetProduct: function (request) {
            return axios.get('/products/search/excel-by-target-product', request);
        },
        getProductsGuidesTemplatesDefault: function (request) {
            return axios.get('/products/guides/templates/default', request);
        },
        getProductsGuides: function (request) {
            return axios.get('/products/guides', request);
        },
        postProductsGuides: function (request) {
            return axios.post('/products/guides', request.data);
        },
        getProductsGuidesTemplatesByTemplateNo: function (reqeust) {
            return axios.get("/products/guides/templates/" + reqeust.params.templateNo);
        },
        postProductsExcelBulk: function (request) {
            return axios.post('/products/excel/bulk', request.data);
        },
        getProductsExcelProductAdminFail: function (request) {
            return axios.get('/products/excel/product-admin-fail', request);
        },
        getRelatedProductsByProductNo: function (request) {
            return axios.get("/products/" + request.pathParams.productNo + "/related-products");
        },
        getRelatedProductsByProductNoV2: function (request) {
            return axios.get("/products/" + request.pathParams.productNo + "/related-products");
        },
        getProductsExcelSampleUrl: function (request) {
            return axios.get('/products/excel/sample-url', request);
        },
        getProductsExcelUpdateAdminForm: function () {
            return axios.get('/products/excel/update-admin-form', { responseType: 'blob' });
        },
        getProductsRemovableSticker: function (request) {
            return axios.get('/products/removable-sticker', request);
        },
        postProductsExcelBulkImages: function (request) {
            return axios.post('/products/excel/bulk/images', request.data);
        },
        postProductsGroupManagementCode: function (request) {
            return axios.post('/products/group-management-code', request.data);
        },
        getProductsGroupManagementCodeAll: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/products/group-management-code/all?" + query);
        },
        deleteProductsGroupManagementCodeMapping: function (request) {
            var query = qs.stringify(request.params);
            return axios.delete("/products/group-management-code/mapping?" + query);
        },
        /** @deprecated getProductsRestockSearchV2 사용해주세요 */
        getProductsRestockSearch: function (request) {
            var query = qs.stringify(request.params, { arrayFormat: 'comma' });
            return axios.get("/products/restock/search?" + query);
        },
        getProductsRestockSearchV2: function (request) {
            var query = qs.stringify(request.params, { arrayFormat: 'comma' });
            return axios.get("/products/restock/search?" + query);
        },
        /** @deprecated deleteProductsRestockV2 사용해주세요 */
        deleteProductsRestock: function (request) {
            var query = qs.stringify(request.params, { arrayFormat: 'comma' });
            return axios.delete("/products/restock?" + query);
        },
        deleteProductsRestockV2: function (request) {
            var query = qs.stringify(request.params, { arrayFormat: 'comma' });
            return axios.delete("/products/restock?" + query);
        },
        /** @deprecated getProductsRestockViewV2 사용해주세요 */
        getProductsRestockView: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/products/restock/view?" + query);
        },
        getProductsRestockViewV2: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/products/restock/view?" + query);
        },
        putProductsRestockSend: function (request) {
            return axios.put('/products/restock/send', request);
        },
        getProductsRestockSendTargets: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/products/restock/send-targets?" + query);
        }
    };
};
